<template>
  <v-row>
    <v-col>
      <v-select
        v-if="DRHs"
        :items="DRHs"
        :label="user.displayName"
        item-text="nomPrenomGestionnaire"
        v-model="DRH"
        @change="changerDRH"
        item-value="uidGestionnaire"
        single-line
        dense
      ></v-select>
      <v-select
        :items="lots"
        v-model="lot"
        v-if="lots"
        label="choix du lot"
        @change="changerLot"
        item-text="libelle"
        return-object
        auto-grow
        dense
      ></v-select>
      <v-data-table
        v-if="lot"
        :headers="headers"
        :items="demandes"
        class="elevation-1"
        :item-class="colorItem"
        multi-sort
        dense
        :sort-by="['erreur', 'etat']"
        :sort-desc="[true, true]"
      >
      </v-data-table>
      &nbsp;
      <div v-if="lot">
        <v-row class="font-weight-bold text-center">
          <v-col class="red" cols="3">Aucune fiche Winpaie trouvée (1)</v-col
          ><v-col class="yellow" cols="3">NPC introuvable (2)</v-col
          ><v-col class="blue" cols="3"
            >Date de fin de situation dépassée (3)</v-col
          >
          <v-col class="justify-right" v-if="erreurWPRH">
            <v-btn
              v-if="wprhLiquidation"
              color="success"
              :href="exportWPRH"
              target="_blank"
              @click="exportWPRHFonction"
              ><v-icon>mdi-export</v-icon> export WPRH</v-btn
            >
            <span v-else>pas d'export vers WPRH</span>
          </v-col>
          <v-col cols="3" v-else-if="demandes.length == 0"
            ><v-progress-circular indeterminate></v-progress-circular
          ></v-col>
          <v-col class="orange" cols="3" v-else>L'export n'est pas actif</v-col>
        </v-row>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import BaseForm from "@/components/base/BaseForm";
import ApiGestionnaireRepository from "@/repositories/ApiGestionnaireRepository";
import { mapState } from "vuex";
import ApiFormComplementaireLotRepository from "@/repositories/ApiFormComplementaireLotRepository";
import ApiFormComplementaireWPRHRepository from "@/repositories/ApiFormComplementaireWPRHRepository";
import ApiParametresRepository from "@/repositories/ApiParametresRepository";

export default {
  name: "FormComplementaireWinpaie",
  components: {},
  extends: BaseForm,
  data() {
    return {
      headers: [
        {
          text: "Matricule",
          value: "matricule",
          align: "start",
        },
        {
          text: "Nom, prénom",
          value: "nomPrenom",
          align: "start",
        },
        {
          text: "N° Dossier Administratif",
          value: "noDossierAdmin",
        },
        {
          text: "Type Demande",
          value: "typeDemande",
        },
        {
          text: "Carte",
          value: "carte",
        },
        {
          text: "Code prime",
          value: "codePrime",
        },
        {
          text: "Mode de calcul",
          value: "modeCalcul",
        },
        {
          text: "Montant Versé",
          value: "montantVerse",
        },
        {
          text: "Date Effet",
          value: "dateEffet",
        },
        {
          text: "Erreur",
          value: "erreur",
        },
        {
          text: "Etat",
          value: "etat",
        },
      ],
      DRHs: null,
      DRH: null,
      lots: null,
      lot: null,
      demandes: [],
      exportWPRH: null,
      erreurWPRH: false,
      wprhLiquidation: false,
    };
  },
  async created() {
    this.DRHs = await ApiGestionnaireRepository.getGestionnaires();
    this.lots = await ApiFormComplementaireLotRepository.getLotsByDRH();
    this.wprhLiquidation = eval(
      await ApiParametresRepository.getWprhLiquidation()
    );
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    async changerDRH() {
      this.lots = await ApiFormComplementaireLotRepository.getLotsByDRHG(
        this.DRH
      );
      this.lot = null;
      this.demandes = [];
      this.erreurWPRH = false;
    },
    async changerLot() {
      this.demandes =
        await ApiFormComplementaireWPRHRepository.getDemandesWPRHByLot(
          this.lot.id
        );

      this.demandes = this.demandes["CREATION"].concat(
        this.demandes["MODIFICATIONSUPPRESSION"]
      );

      this.erreurWPRH = false;
      this.erreurWPRH = this.erreurWPRHFonction();
      if (this.lot != null) {
        this.exportWPRH = await ApiFormComplementaireWPRHRepository.exportWPRH(
          this.lot.id
        );
      }
    },
    colorItem(item) {
      if (item.erreur)
        if (item.erreur == 1) return "red";
        else if (item.erreur == 2) return "yellow";
        else return "blue";
      return "";
    },
    async exportWPRHFonction() {
      if (this.lot != null) {
        this.lot.exportPaie = true;
        await ApiFormComplementaireLotRepository.updateLot(this.lot);
        this.erreurWPRH = false;
        this.lots = this.lots.filter((element) => element != this.lot);
      } else {
        this.$toast.warn("aucun lot sélectionné.");
      }
    },
    erreurWPRHFonction() {
      return true;
    },
  },
};
</script>
